export default __webpack_public_path__ + "static/media/touch.0a44f183.png";